function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
export function isEqual(a, b) {
  return a === b;
}
export function getItemByValue(value, data) {
  var isEqualFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : isEqual;
  var item = data.find(function (m) {
    return isEqualFn(m.value, value);
  });
  if (item) return item;
  var _iterator = _createForOfIteratorHelper(data),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var d = _step.value;
      if (d.children) {
        var sonItem = getItemByValue(value, d.children, isEqualFn);
        if (sonItem) return sonItem;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return null;
}

//TODO: 循环修改，去掉result
export var getItemsByValues = function getItemsByValues(value, data, result) {
  var isEqualFn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : isEqual;
  var all = result || [];
  var items = data.filter(function (m) {
    return value.some(function (v) {
      return isEqualFn(m.value, v);
    });
  });
  all.push.apply(all, _toConsumableArray(items));
  var _iterator2 = _createForOfIteratorHelper(data),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var d = _step2.value;
      if (d.children) {
        getItemsByValues(value, d.children, all, isEqualFn);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return all;
};
var findValue = function findValue(value, data) {
  var isEqualFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : isEqual;
  var item = data.find(function (m) {
    var _m$children;
    return (_m$children = m.children) === null || _m$children === void 0 ? void 0 : _m$children.some(function (n) {
      return isEqualFn(n.value, value);
    });
  });
  if (item) {
    return [item.value];
  }
  return undefined;
};
export var getParentValues = function getParentValues(value, data) {
  var isEqualFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : isEqual;
  if (!value) return [];
  var parent = findValue(value, data, isEqualFn);
  if (parent) return parent;
  var _iterator3 = _createForOfIteratorHelper(data),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var d = _step3.value;
      if (d.children) {
        var values = [d.value];
        var parents = getParentValues(value, d.children, isEqualFn);
        if (parents) {
          values.push.apply(values, _toConsumableArray(parents));
          return values;
        }
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
};
export var getChildValues = function getChildValues(value, data) {
  var isEqualFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : isEqual;
  var item = getItemByValue(value, data, isEqualFn);
  if (!item) return [];
  if (!item.children) return [item.value];
  var values = [];
  var _iterator4 = _createForOfIteratorHelper(item.children),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var c = _step4.value;
      var v = getChildValues(c.value, item.children, isEqualFn);
      if (v) {
        values.push.apply(values, _toConsumableArray(v));
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return values;
};
var getLabel = function getLabel(value, data) {
  var isEqualFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : isEqual;
  var item = data.find(function (m) {
    var _m$children2;
    return (_m$children2 = m.children) === null || _m$children2 === void 0 ? void 0 : _m$children2.some(function (n) {
      return isEqualFn(n.value, value);
    });
  });
  if (item) {
    return [item.label];
  }
  return undefined;
};
export var getParentLabels = function getParentLabels(value, data) {
  var isEqualFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : isEqual;
  if (!value) return [];
  var parent = getLabel(value, data, isEqualFn);
  if (parent) return parent;
  var _iterator5 = _createForOfIteratorHelper(data),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var d = _step5.value;
      if (d.children) {
        var labels = [d.label];
        var parents = getParentLabels(value, d.children, isEqualFn);
        if (parents) {
          labels.push.apply(labels, _toConsumableArray(parents));
          return labels;
        }
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
};